import { render } from "./WorkStationProfileLogo.vue?vue&type=template&id=2915fa93&scoped=true&ts=true"
import script from "./WorkStationProfileLogo.vue?vue&type=script&lang=ts"
export * from "./WorkStationProfileLogo.vue?vue&type=script&lang=ts"

import "./WorkStationProfileLogo.vue?vue&type=style&index=0&id=2915fa93&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2915fa93"]])

export default __exports__